/**
 * Logos del pie según el tema.
 *
 * - Claro: el logo de siempre (`logoichtys-technology.png`, fondo transparente).
 * - Oscuro / alto contraste: `src/assets/img/ichtys-logo-dark.png` cuando exista. Se busca con
 *   `require.context` para que la compilación no falle mientras el archivo no esté: si falta,
 *   `FOOTER_LOGO_DARK` queda `undefined` y el pie usa el logo claro adaptado por CSS
 *   (`.footerLogo.footerLogoAdapted` en theme.css) con los colores aclarados.
 */

declare global {
  interface NodeRequire {
    context(directory: string, useSubdirectories: boolean, regExp: RegExp): {
      keys(): string[];
      (id: string): unknown;
    };
  }
}

const asUrl = (mod: unknown): string | undefined => {
  if (typeof mod === 'string') return mod;
  const withDefault = mod as { default?: unknown } | undefined;
  return typeof withDefault?.default === 'string' ? withDefault.default : undefined;
};

export const FOOTER_LOGO_LIGHT: string = asUrl(require('../../assets/img/logoichtys-technology.png')) ?? '';

/** Ruta reservada para el logo del modo oscuro: `src/assets/img/ichtys-logo-dark.png`. */
export const FOOTER_LOGO_DARK: string | undefined = (() => {
  try {
    // `require.context` lo resuelve webpack en la compilación; en Jest no existe y cae al catch.
    const ctx = require.context('../../assets/img', false, /^\.\/ichtys-logo-dark\.png$/);
    const [key] = ctx.keys();
    return key ? asUrl(ctx(key)) : undefined;
  } catch {
    return undefined;
  }
})();
